export default __webpack_public_path__ + "static/image-contact-761911effc94730783626bde683d8328.png";